import tokenService from '../_services/token.service';
import { decodeToken } from '../models/decode-token';

export const checkIfSuperuserToken = () => {
  const token = tokenService.getLocalAccessToken();
  const decodedToken = decodeToken(token);
  return decodedToken?.user_id && !decodedToken.candidate_id && !decodedToken.company_id;
};
